import { AgentProfileDto, AgentProfileId, EtxeApiSlugs, ListPagination } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils';

export class EtxeAgentsAdminConnector extends ApiConnector<AgentProfileDto, AgentProfileDto, AgentProfileId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.AGENTS);
  }

  list = (pagination?: ListPagination): Observable<AgentProfileDto[]> =>
    this.apiCaller.getRequest<AgentProfileDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  count = (pagination?: ListPagination): Observable<number> =>
    this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );
}
